import { PropsWithChildren } from "react";

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/_atoms/tooltip";

export interface ExplanationTooltipProps extends PropsWithChildren {
  disabled?: boolean;
  content: string;
  delayDuration?: number;
}

export const ExplanationTooltip = ({ children, disabled, content, delayDuration = 1000 }: ExplanationTooltipProps) => {
  if (disabled) {
    return <div>{children}</div>;
  }

  return (
    <TooltipProvider>
      <Tooltip delayDuration={delayDuration}>
        <TooltipTrigger asChild>
          <div>{children}</div>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{content}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
